var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWritingSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8644 0.748361C11.1104 0.50488 11.6555 0.0121114 12.0033 0.0121114C12.1368 0.0119169 12.0033 -0.015063 12.422 0.0121444L13.459 1.04212C13.7048 1.28568 13.9795 1.43228 13.9795 1.77666C13.4603 2.29081 13.7062 2.04726 13.4603 2.29081L12.422 3.31911L10.3453 1.26251L10.8644 0.748361ZM9.8261 1.77666L5.67271 5.37572C5.67271 5.37572 5.67271 5.37572 5.15354 5.88987L4.93451 7.15541C4.93451 7.49987 4.68843 8.06491 4.93438 8.30848C5.18032 8.55204 5.89815 8.45418 6.24596 8.45418L7.23023 8.46062C7.23023 8.46062 7.50352 8.19005 7.7494 7.94647L11.9028 3.83326L10.3453 2.29081L9.8261 1.77666Z",
    fill: "#FFA177"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.96718 7.80502H2.31145C1.96363 7.80502 1.63006 7.94186 1.38412 8.18542C1.13817 8.42899 1 8.75933 1 9.10379C1 9.44824 1.13817 9.77859 1.38412 10.0222C1.63006 10.2657 1.96363 10.4026 2.31145 10.4026H11.4916C11.8394 10.4026 12.173 10.5394 12.419 10.783C12.6649 11.0265 12.8031 11.3569 12.8031 11.7013C12.8031 12.0458 12.6649 12.3761 12.419 12.6197C12.173 12.8632 11.8394 13.0001 11.4916 13.0001H8.86872",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWritingSelected);
export default __webpack_public_path__ + "static/media/WritingSelected.68d7c899e0b01043282136e08f103db7.svg";
export { ForwardRef as ReactComponent };